import { writable } from "svelte/store";

export type ToastVariant = "info" | "success" | "warning" | "danger";

export type Toast = {
	id: string;
	variant: ToastVariant;
	message: string;
	durationMs: number;
};

export const toasts = writable<Array<Toast>>([]);

export function pushToast(input: {
	variant: ToastVariant;
	message: string;
	durationMs?: number;
}): string {
	const id = crypto.randomUUID();
	const durationMs = input.durationMs ?? 5000;
	toasts.update((current) => [
		...current,
		{ id, variant: input.variant, message: input.message, durationMs },
	]);
	setTimeout(() => dismissToast(id), durationMs);
	return id;
}

export function dismissToast(id: string): void {
	toasts.update((current) => current.filter((t) => t.id !== id));
}
